/* Silk Scarfs - fiche produit ss-product : variantes, galerie, livraison estimee, ajout au panier (tiroir Ella). */
(function () {
  'use strict';

  /* Meme arrondi que le snippet Liquid ss-size : demi-pouce le plus proche, centimetre entier.
     Entree « 27.5 x 27.5 in » ou « 70 x 70 cm », sortie { in: '27.5 × 27.5', cm: '70 × 70' }. */
  function measure(str) {
    var raw = String(str || '').toLowerCase().replace(/×/g, 'x').replace(/"/g, '');
    var src = raw.indexOf('cm') > -1 ? 'cm' : 'in';
    raw = raw.replace(/centimet(er|re)s?/g, '').replace(/cm/g, '').replace(/inch(es)?/g, '').replace(/in/g, '');
    var ins = [], cms = [];
    raw.split('x').forEach(function (part) {
      var n = parseFloat(part);
      if (!(n > 0)) return;
      if (src === 'cm') {
        var c = Math.round(n);
        var half = Math.floor((c * 200 + 127) / 254);
        ins.push(String(half / 2));
        cms.push(String(c));
      } else {
        ins.push(String(n));
        cms.push(String(Math.round(n * 2.54)));
      }
    });
    return { inch: ins.join(' × '), cm: cms.join(' × ') };
  }

  function init(root) {
    moveSizeGuide(root);
    if (!root || root.__ssPdp) return;
    root.__ssPdp = true;

    var dataEl = root.querySelector('[data-ss-variants]');
    var data = { options: [], variants: [] };
    try { data = JSON.parse(dataEl.textContent); } catch (e) { /* pas de donnees : on garde le formulaire natif */ }

    var form = root.querySelector('[data-ss-form]');
    var idInput = form ? form.querySelector('[data-ss-variant-input]') : null;
    var pickers = Array.prototype.slice.call(root.querySelectorAll('[data-ss-option]'));

    /* ---------- Galerie ---------- */
    var track = root.querySelector('[data-ss-slides]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ss-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ss-dot]'));

    function setActive(index) {
      thumbs.concat(dots).forEach(function (t) {
        var on = parseInt(t.getAttribute('data-ss-thumb') || t.getAttribute('data-ss-dot'), 10) === index;
        t.classList.toggle('is-active', on);
        if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
      });
    }
    function goTo(index, smooth) {
      if (!track || !slides[index]) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: index * track.clientWidth, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      setActive(index);
    }
    thumbs.concat(dots).forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-ss-thumb') || t.getAttribute('data-ss-dot'), 10), true); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-ss-goto]'), function (btn) {
      btn.addEventListener('click', function () {
        goTo(parseInt(btn.getAttribute('data-ss-goto'), 10), true);
        var r = track ? track.getBoundingClientRect() : null;
        if (r && (r.top < 0 || r.bottom > window.innerHeight)) track.scrollIntoView({ block: 'center' });
      });
    });
    var start = track ? parseInt(track.getAttribute('data-ss-start'), 10) || 0 : 0;
    if (start > 0) goTo(start, false);
    if (track && slides.length > 1) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          setActive(Math.max(0, Math.min(slides.length - 1, i)));
        });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var cur = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        var next = Math.max(0, Math.min(slides.length - 1, cur + (e.key === 'ArrowRight' ? 1 : -1)));
        e.preventDefault();
        goTo(next, true);
      });
    }

    initLightbox(root, goTo);
    initMore(root);
    initStickyBar(root);

    /* ---------- Variantes ---------- */
    function selectedOptions() {
      return pickers.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function findById(id) {
      for (var i = 0; i < data.variants.length; i++) { if (String(data.variants[i].id) === String(id)) return data.variants[i]; }
      return null;
    }
    var addBtn = root.querySelector('[data-ss-add]');
    var soldLabel = (addBtn && addBtn.getAttribute('data-soldout')) || 'Sold out';
    function markAvailability(opts) {
      pickers.forEach(function (fs, i) {
        Array.prototype.forEach.call(fs.querySelectorAll('input'), function (input) {
          var test = opts.slice();
          test[i] = input.value;
          var v = findVariant(test);
          var off = !v || !v.available;
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', off);
          if (off) { input.setAttribute('aria-label', input.value + ', ' + soldLabel); } else { input.removeAttribute('aria-label'); }
        });
      });
    }
    /* index de l'option de taille (noms reglables dans la section) */
    function sizeIndex() {
      var names = (root.getAttribute('data-ss-size-names') || 'size').toLowerCase().split(',');
      for (var k = 0; k < names.length; k++) names[k] = names[k].replace(/\s+/g, '');
      var found = -1;
      data.options.forEach(function (name, i) {
        if (found < 0 && names.indexOf(String(name).toLowerCase().replace(/\s+/g, '')) > -1) found = i;
      });
      return found;
    }

    function moneyNum(s) { var m = String(s || '').match(/\d[\d,]*(?:\.\d+)?/g); return m ? parseFloat(m[m.length - 1].replace(/,/g, '')) : 0; }

    function setText(sel, value) {
      Array.prototype.forEach.call(root.querySelectorAll(sel), function (el) { el.textContent = value; });
    }

    function update(pushUrl) {
      var opts = selectedOptions();
      var v = findVariant(opts);
      markAvailability(opts);

      pickers.forEach(function (fs, i) { setText('[data-ss-opt-value="' + i + '"]', opts[i] || ''); });

      var sub = root.querySelector('[data-ss-subtitle]');
      if (sub) {
        var txt = sub.getAttribute('data-template') || '';
        data.options.forEach(function (name, i) { txt = txt.split('[' + name + ']').join(opts[i] || ''); });
        sub.textContent = txt;
      }

      /* Les lignes du passeport qui portent [in], [cm] ou [size] suivent la variante choisie.
         L'attribut garde le gabarit d'origine, sinon le premier remplacement l'effacerait. */
      var passRows = root.querySelectorAll('[data-ss-pass-size]');
      if (passRows.length) {
        var names = (root.getAttribute('data-ss-size-names') || 'size').toLowerCase().split(',');
        for (var pn = 0; pn < names.length; pn++) names[pn] = names[pn].replace(/\s+/g, '');
        var si = -1;
        data.options.forEach(function (name, i) {
          if (si < 0 && names.indexOf(String(name).toLowerCase().replace(/\s+/g, '')) > -1) si = i;
        });
        if (si > -1) {
          var m = measure(opts[si]);
          var both = m.inch ? (m.inch + ' in' + (m.cm ? ' (' + m.cm + ' cm)' : '')) : '';
          Array.prototype.forEach.call(passRows, function (el) {
            var tpl = el.getAttribute('data-ss-pass-size') || '';
            el.textContent = tpl.split('[size]').join(both).split('[in]').join(m.inch).split('[cm]').join(m.cm);
          });
        }
      }

      var note = root.querySelector('[data-ss-size-note]');
      if (note) note.textContent = (v && v.note) ? v.note : note.getAttribute('data-default');

      var add = root.querySelector('[data-ss-add]');
      var addText = root.querySelector('[data-ss-add-text]');
      var soldout = root.querySelector('[data-ss-soldout]');
      var compare = root.querySelector('[data-ss-compare]');

      var busy = add && add.getAttribute('aria-busy') === 'true';
      if (!v) {
        if (idInput) idInput.value = '';
        if (add) add.disabled = true;
        var sbOff = root.querySelector('[data-ss-sbar-add]');
        if (sbOff) sbOff.disabled = true;
        if (addText && add) addText.textContent = add.getAttribute('data-soldout');
        return;
      }
      if (idInput) idInput.value = v.id;
      setText('[data-ss-price]', v.price);
      if (compare) { compare.hidden = !v.compare; compare.textContent = v.compare || ''; }
      /* 25/10 : pourcentage et label « Sale » (rendus seulement sur les produits concernes) suivent la variante */
      var pctEl = root.querySelector('[data-ss-pct]');
      if (pctEl) {
        var nowN = moneyNum(v.price), wasN = moneyNum(v.compare);
        var pc = (v.compare && wasN > nowN && nowN > 0) ? Math.floor((wasN - nowN) * 100 / wasN) : 0;
        if (pc > 0) { pctEl.textContent = '-' + pc + '%'; pctEl.hidden = false; } else { pctEl.hidden = true; }
      }
      var saleTag = root.querySelector('[data-ss-sale]');
      if (saleTag) saleTag.hidden = !v.compare;
      var sbWas = root.querySelector('[data-ss-sbar-was]');
      if (sbWas) { sbWas.hidden = !v.compare; sbWas.textContent = v.compare || ''; }
      var sbVar = root.querySelector('[data-ss-sbar-variant]');
      if (sbVar) {
        var sbSi = sizeIndex();
        sbVar.textContent = opts.map(function (o, i) {
          if (i !== sbSi || !o) return o;
          var sm = measure(o);
          return sm.inch ? sm.inch + ' in' + (sm.cm && sm.cm !== sm.inch ? ' (' + sm.cm + ' cm)' : '') : o;
        }).filter(function (o) { return o && o !== 'Default Title'; }).join(' · ');
      }
      var sbBtn = root.querySelector('[data-ss-sbar-add]');
      if (sbBtn) {
        sbBtn.disabled = !v.available;
        var sbTxt = sbBtn.querySelector('[data-ss-sbar-text]');
        if (sbTxt) sbTxt.textContent = sbBtn.getAttribute(v.available ? 'data-label' : 'data-soldout') || '';
      }
      if (soldout) soldout.hidden = v.available;
      if (add) {
        add.disabled = busy || !v.available;
        if (addText) {
          var withPrice = add.getAttribute('data-show-price') === 'true';
          addText.textContent = v.available ? add.getAttribute('data-label') + (withPrice ? ', ' + v.price : '') : add.getAttribute('data-soldout');
        }
      }
      if (v.media) {
        for (var k = 0; k < slides.length; k++) {
          if (String(slides[k].getAttribute('data-media-id')) === String(v.media)) {
            goTo(k, true);
            if (root.__ssMore) root.__ssMore.reveal(k);
            break;
          }
        }
      }
      if (pushUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-ss-option]')) update(true);
    });
    if (pickers.length) markAvailability(selectedOptions());

    /* ---------- Livraison estimee ---------- */
    var d = root.querySelector('[data-ss-delivery]');
    if (d) {
      try {
        var cutoff = parseInt(d.getAttribute('data-cutoff'), 10) || 0;
        var proc = parseInt(d.getAttribute('data-processing'), 10) || 0;
        var tmin = parseInt(d.getAttribute('data-min'), 10) || 1;
        var tmax = Math.max(tmin, parseInt(d.getAttribute('data-max'), 10) || tmin);
        var weekends = d.getAttribute('data-weekends') === 'true';
        var isWorkday = function (dt) { return weekends || (dt.getDay() !== 0 && dt.getDay() !== 6); };
        var now = new Date();
        var shipDay = new Date(now);
        shipDay.setHours(cutoff, 0, 0, 0);
        if (now >= shipDay || !isWorkday(shipDay)) {
          do { shipDay.setDate(shipDay.getDate() + 1); } while (!isWorkday(shipDay));
        }
        var hours = Math.max(1, Math.ceil((shipDay - now) / 3600000));
        var addDays = function (dt, n) {
          var x = new Date(dt);
          while (n > 0) { x.setDate(x.getDate() + 1); if (isWorkday(x)) n--; }
          return x;
        };
        var ready = addDays(shipDay, proc);
        var from = addDays(ready, tmin);
        var to = addDays(ready, tmax);
        var fmt = new Intl.DateTimeFormat(d.getAttribute('data-locale') || 'en-US', { month: 'short', day: 'numeric' });
        var dateText = from.getTime() === to.getTime() ? fmt.format(from)
          : (typeof fmt.formatRange === 'function' ? fmt.formatRange(from, to) : fmt.format(from) + ' – ' + fmt.format(to));
        var tpl = d.getAttribute('data-template') || '';
        var main = d.querySelector('[data-ss-delivery-main]');
        if (tpl && main) main.textContent = tpl.split('[hours]').join(String(hours)).split('[date]').join(dateText);
      } catch (e) { /* on garde la phrase de repli */ }
    }

    /* ---------- Ajout au panier ---------- */
    if (!form) return;
    var errorEl = root.querySelector('[data-ss-error]');
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !idInput) return;
      e.preventDefault();
      if (!idInput.value) return;
      var add = root.querySelector('[data-ss-add]');
      if (add && add.getAttribute('aria-busy') === 'true') return;
      if (errorEl) errorEl.textContent = '';

      var initials = form.querySelector('.ss-pdp__input--initials');
      if (initials && initials.value && !initials.checkValidity()) {
        initials.closest('details') && (initials.closest('details').open = true);
        initials.reportValidity();
        return;
      }

      var fd = new FormData(form);
      var props = {};
      fd.forEach(function (value, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && String(value).trim() !== '') props[m[1]] = String(value).trim();
      });
      if (initials && initials.value.trim() !== '') {
        props[initials.name.replace(/^properties\[|\]$/g, '')] = initials.value.trim().toUpperCase();
      }
      var items = [{ id: Number(idInput.value), quantity: Number(fd.get('quantity') || 1), properties: props }];
      var titleEl = root.querySelector('.ss-pdp__title');
      var forLabel = (titleEl ? titleEl.textContent.trim() : '') + (selectedOptions().filter(Boolean).length ? ' (' + selectedOptions().filter(Boolean).join(' / ') + ')' : '');
      Array.prototype.forEach.call(form.querySelectorAll('[data-ss-addon]'), function (el) {
        var on = el.type === 'checkbox' ? el.checked : String(el.value).trim() !== '';
        if (on) items.push({ id: Number(el.getAttribute('data-ss-addon')), quantity: 1, properties: { For: forLabel } });
      });

      var body = { items: items };
      var cart = document.querySelector('cart-drawer');
    if (window.SSShell && window.SSShell.sectionId && window.SSShell.sectionId()) {
      body.sections = window.SSShell.sectionId();
      body.sections_url = window.location.pathname;
    }
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

      if (add) { add.setAttribute('aria-busy', 'true'); add.disabled = true; }
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) {
            if (errorEl) errorEl.textContent = res.json.description || res.json.message || 'Something went wrong. Please try again.';
            return;
          }
          var json = res.json;
          if (json.items && json.items[0] && json.id == null) json.id = json.items[0].id;
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ss-product', productVariantId: idInput.value, cartData: json });
          }
          if (window.SSShell && window.SSShell.added) {
            window.SSShell.added(json);
          } else if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(json);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () {
          if (errorEl) errorEl.textContent = 'Something went wrong. Please try again.';
        })
        .finally(function () {
          if (!add) return;
          add.removeAttribute('aria-busy');
          var cv = findById(idInput.value);
          add.disabled = data.variants.length ? !(cv && cv.available) : false;
        });
    });
  }

  /* La visionneuse (refaite le 27/09). Plein ecran : barre (compteur, indice, croix), piste
     d'images, vignettes. La piste est un defilement accroche (scroll-snap) : au doigt on glisse
     d'une image a l'autre avec l'inertie native ; a la souris, fleches, clavier et vignettes.
     Zoom : clic a l'ordinateur (l'image suit ensuite la souris), double tap ou pincement au
     doigt (puis on se deplace a un doigt), Ctrl + molette / pincement du pave tactile.
     Tant qu'une image est zoomee, la piste est figee. Echap dezoome d'abord, puis ferme. */
  function initLightbox(root, goTo) {
    var lb = root.querySelector('[data-ss-lb]');
    if (!lb || typeof lb.showModal !== 'function') return;
    var track = lb.querySelector('[data-ss-lb-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-ss-lb-slide]')) : [];
    if (!slides.length) return;
    var countEl = lb.querySelector('[data-ss-lb-count]');
    var hintEl = lb.querySelector('[data-ss-lb-hint]');
    var prevBtn = lb.querySelector('[data-ss-lb-prev]');
    var nextBtn = lb.querySelector('[data-ss-lb-next]');
    var closeBtn = lb.querySelector('[data-ss-lb-close]');
    var strip = lb.querySelector('[data-ss-lb-strip]');
    var thumbs = Array.prototype.slice.call(lb.querySelectorAll('[data-ss-lb-go]'));
    var ZOOM = Math.max(1.5, (parseInt(lb.getAttribute('data-zoom'), 10) || 250) / 100);
    var MAX = Math.max(4, ZOOM);
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var at = 0;
    var zoomed = false;
    var st = { s: 1, x: 0, y: 0 };
    var animUntil = 0;
    var lastTouch = 0;
    var hinted = false;
    var target = -1;
    var targetTimer = 0;

    function now() { return new Date().getTime(); }
    function clampI(i) { return Math.max(0, Math.min(slides.length - 1, i)); }
    function mediaOf(i) { return parseInt(slides[i].getAttribute('data-ss-lb-slide'), 10) || 0; }
    function slideOf(mediaIndex) {
      for (var k = 0; k < slides.length; k++) { if (mediaOf(k) === mediaIndex) return k; }
      return 0;
    }
    function imgOf(i) { return slides[i] ? slides[i].querySelector('img') : null; }

    /* L'image a l'echelle 1 dans sa diapositive (offset* ignorent le transform), et la
       diapositive elle-meme : c'est elle qui coupe, le zoom se cale donc sur ses bords. */
    function box(img) {
      var sl = img.parentNode;
      var r = sl.getBoundingClientRect();
      return { l: img.offsetLeft, t: img.offsetTop, w: img.offsetWidth || 1, h: img.offsetHeight || 1, W: sl.clientWidth, H: sl.clientHeight, rx: r.left, ry: r.top };
    }
    /* sur un axe : plus grande que la diapositive, l'image ne decouvre jamais de vide ;
       plus petite, elle reste centree */
    function axis(off, size, S, s, v) {
      var span = size * s;
      if (span <= S) return (S - span) / 2 - off;
      return Math.min(-off, Math.max(S - off - span, v));
    }
    function apply(img, animate) {
      if (!img) return;
      if (animate && !reduce.matches) animUntil = now() + 300;
      img.style.transition = now() < animUntil ? '' : 'none';
      img.style.transform = st.s === 1 ? '' : 'translate(' + st.x + 'px,' + st.y + 'px) scale(' + st.s + ')';
    }
    function setZoomed(on, img) {
      zoomed = !!on;
      lb.classList.toggle('is-zoomed', zoomed);
      if (!zoomed) return;
      if (hintEl && !hinted) { hinted = true; hintEl.hidden = true; }
      /* une source a la hauteur du grossissement (le srcset monte a 1800 px) */
      if (img && !img.getAttribute('data-ss-big')) {
        img.setAttribute('data-ss-big', '1');
        img.setAttribute('sizes', Math.ceil(img.offsetWidth * MAX) + 'px');
      }
    }
    function reset(animate) {
      st.s = 1; st.x = 0; st.y = 0;
      apply(imgOf(at), animate);
      setZoomed(false);
    }
    /* grossit a l'echelle s en gardant sous le doigt le point (cx, cy) */
    function zoomAt(img, s, cx, cy, animate) {
      var b = box(img);
      var px = cx - b.rx, py = cy - b.ry;
      var u = (px - b.l - st.x) / st.s, v = (py - b.t - st.y) / st.s;
      st.s = s;
      st.x = axis(b.l, b.w, b.W, s, px - b.l - s * u);
      st.y = axis(b.t, b.h, b.H, s, py - b.t - s * v);
      apply(img, animate);
    }
    /* souris : la place du pointeur sur l'image d'origine choisit la partie montree */
    function follow(img, cx, cy, animate) {
      if (!img) return;
      var b = box(img);
      var fx = Math.min(1, Math.max(0, (cx - b.rx - b.l) / b.w));
      var fy = Math.min(1, Math.max(0, (cy - b.ry - b.t) / b.h));
      var sw = b.w * st.s, sh = b.h * st.s;
      st.x = sw > b.W ? fx * (b.W - sw) - b.l : (b.W - sw) / 2 - b.l;
      st.y = sh > b.H ? fy * (b.H - sh) - b.t : (b.H - sh) / 2 - b.t;
      apply(img, animate);
    }
    /* fin de pincement : on ramene l'echelle sous le plafond et l'image dans le cadre */
    function settle(img) {
      if (!img) return;
      var b = box(img);
      if (st.s > MAX) {
        var cx = b.W / 2, cy = b.H / 2;
        var u = (cx - b.l - st.x) / st.s, v = (cy - b.t - st.y) / st.s;
        st.s = MAX; st.x = cx - b.l - MAX * u; st.y = cy - b.t - MAX * v;
      }
      st.x = axis(b.l, b.w, b.W, st.s, st.x);
      st.y = axis(b.t, b.h, b.H, st.s, st.y);
      apply(img, true);
    }

    function centerThumb(t, smooth) {
      if (!strip) return;
      var left = t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: smooth && !reduce.matches ? 'smooth' : 'auto' });
    }
    function eager(i) {
      for (var k = i - 1; k <= i + 1; k++) {
        var im = imgOf(k);
        if (im && im.getAttribute('loading') === 'lazy') im.setAttribute('loading', 'eager');
      }
    }
    function paint(i, smooth) {
      if (i !== at) reset(false);
      at = i;
      if (countEl) countEl.textContent = (i + 1) + ' / ' + slides.length;
      if (prevBtn) prevBtn.setAttribute('aria-disabled', i === 0 ? 'true' : 'false');
      if (nextBtn) nextBtn.setAttribute('aria-disabled', i === slides.length - 1 ? 'true' : 'false');
      var m = mediaOf(i);
      thumbs.forEach(function (t) {
        var on = (parseInt(t.getAttribute('data-ss-lb-go'), 10) || 0) === m;
        t.classList.toggle('is-active', on);
        if (on) { t.setAttribute('aria-current', 'true'); centerThumb(t, smooth); } else { t.removeAttribute('aria-current'); }
      });
      eager(i);
    }
    function go(i, smooth) {
      i = clampI(i);
      if (i === at) { if (zoomed) reset(true); return; }
      var anim = smooth && !reduce.matches;
      if (anim) {
        /* pendant le defilement anime, les images traversees ne repeignent pas le compteur */
        target = i;
        clearTimeout(targetTimer);
        targetTimer = setTimeout(function () { target = -1; }, 800);
      }
      track.scrollTo({ left: i * track.clientWidth, behavior: anim ? 'smooth' : 'auto' });
      paint(i, smooth);
    }
    function open(mediaIndex) {
      var i = slideOf(mediaIndex);
      if (hintEl && !hinted) {
        var txt = hintEl.getAttribute(fine.matches ? 'data-mouse' : 'data-touch') || '';
        hintEl.textContent = txt;
        hintEl.hidden = !txt;
      }
      document.documentElement.classList.add('ss-lb-lock');
      lb.showModal();
      reset(false);
      at = i;
      track.scrollLeft = i * track.clientWidth;
      paint(i, false);
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-ss-lb-open]'), function (btn) {
      btn.addEventListener('click', function () { open(parseInt(btn.getAttribute('data-ss-lb-open'), 10) || 0); });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(slideOf(parseInt(t.getAttribute('data-ss-lb-go'), 10) || 0), true); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { go(at - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(at + 1, true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { lb.close(); });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var i = clampI(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
        if (target > -1) { if (i === target) target = -1; return; }
        if (i !== at) paint(i, true);
      });
    }, { passive: true });

    lb.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k !== 'ArrowRight' && k !== 'ArrowLeft' && k !== 'Home' && k !== 'End') return;
      e.preventDefault();
      go(k === 'Home' ? 0 : k === 'End' ? slides.length - 1 : at + (k === 'ArrowRight' ? 1 : -1), true);
    });
    lb.addEventListener('cancel', function (e) {
      if (zoomed) { e.preventDefault(); reset(true); }
    });
    lb.addEventListener('close', function () {
      reset(false);
      gesture = null;
      document.documentElement.classList.remove('ss-lb-lock');
      if (goTo) goTo(mediaOf(at), false);
    });
    window.addEventListener('resize', function () {
      if (!lb.open) return;
      reset(false);
      track.scrollLeft = at * track.clientWidth;
    });

    /* ---- souris ---- */
    track.addEventListener('click', function (e) {
      if (now() - lastTouch < 700) return; /* un tap tactile est traite plus bas */
      var img = imgOf(at);
      if (!img) return;
      if (zoomed) { reset(true); return; }
      /* clic a cote de la photo : on ferme, comme partout */
      if (e.target !== img) { lb.close(); return; }
      st.s = ZOOM;
      setZoomed(true, img);
      follow(img, e.clientX, e.clientY, true);
    });
    track.addEventListener('mousemove', function (e) {
      if (!zoomed || now() - lastTouch < 700) return;
      follow(imgOf(at), e.clientX, e.clientY, false);
    });
    /* pincement du pave tactile (= molette + Ctrl) */
    track.addEventListener('wheel', function (e) {
      if (!e.ctrlKey) return;
      var img = imgOf(at);
      if (!img) return;
      e.preventDefault();
      var s = Math.min(MAX, Math.max(1, st.s * Math.exp(-e.deltaY * 0.01)));
      if (s <= 1.01) { reset(false); return; }
      if (!zoomed) setZoomed(true, img);
      st.s = s;
      follow(img, e.clientX, e.clientY, false);
    }, { passive: false });
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* ---- doigt ---- */
    var gesture = null, lastTap = 0, tapX = 0, tapY = 0;
    function dist(a, c) { return Math.sqrt(Math.pow(a.clientX - c.clientX, 2) + Math.pow(a.clientY - c.clientY, 2)) || 1; }
    function startPan(t) { gesture = { mode: 'pan', x0: t.clientX, y0: t.clientY, tx: st.x, ty: st.y, moved: false }; }
    track.addEventListener('touchstart', function (e) {
      lastTouch = now();
      var img = imgOf(at);
      if (!img) return;
      if (e.touches.length === 2) {
        var a = e.touches[0], c = e.touches[1];
        var b = box(img);
        var mx = (a.clientX + c.clientX) / 2 - b.rx, my = (a.clientY + c.clientY) / 2 - b.ry;
        gesture = { mode: 'pinch', d0: dist(a, c), s0: st.s, u: (mx - b.l - st.x) / st.s, v: (my - b.t - st.y) / st.s };
        lastTap = 0;
      } else if (e.touches.length === 1) {
        if (zoomed) startPan(e.touches[0]);
        else gesture = { mode: 'tap', x0: e.touches[0].clientX, y0: e.touches[0].clientY, moved: false };
      }
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (!gesture) return;
      var img = imgOf(at);
      if (!img) return;
      if (gesture.mode === 'pinch' && e.touches.length >= 2) {
        if (e.cancelable) e.preventDefault();
        var a = e.touches[0], c = e.touches[1];
        var b = box(img);
        var s = Math.min(MAX * 1.2, Math.max(0.8, gesture.s0 * dist(a, c) / gesture.d0));
        if (!zoomed && s > 1.02) setZoomed(true, img);
        st.s = s;
        st.x = (a.clientX + c.clientX) / 2 - b.rx - b.l - s * gesture.u;
        st.y = (a.clientY + c.clientY) / 2 - b.ry - b.t - s * gesture.v;
        apply(img, false);
      } else if (gesture.mode === 'pan' && e.touches.length === 1) {
        if (e.cancelable) e.preventDefault();
        var t = e.touches[0];
        var b2 = box(img);
        var dx = t.clientX - gesture.x0, dy = t.clientY - gesture.y0;
        if (Math.abs(dx) + Math.abs(dy) > 8) gesture.moved = true;
        st.x = axis(b2.l, b2.w, b2.W, st.s, gesture.tx + dx);
        st.y = axis(b2.t, b2.h, b2.H, st.s, gesture.ty + dy);
        apply(img, false);
      } else if (gesture.mode === 'tap' && e.touches.length === 1) {
        var t2 = e.touches[0];
        if (Math.abs(t2.clientX - gesture.x0) + Math.abs(t2.clientY - gesture.y0) > 10) gesture.moved = true;
      }
    }, { passive: false });
    function endTouch(e) {
      lastTouch = now();
      if (!gesture) return;
      var img = imgOf(at);
      if (gesture.mode === 'pinch') {
        if (e.touches.length >= 2) return;
        if (st.s <= 1.05) reset(true); else settle(img);
        if (e.touches.length === 1 && zoomed) startPan(e.touches[0]); else gesture = null;
        return;
      }
      if (e.type === 'touchend' && !gesture.moved && e.changedTouches.length) {
        /* double tap : zoom au point touche, ou retour a l'image entiere */
        var t = e.changedTouches[0];
        var tm = now();
        if (tm - lastTap < 320 && Math.abs(t.clientX - tapX) < 30 && Math.abs(t.clientY - tapY) < 30) {
          lastTap = 0;
          if (e.cancelable) e.preventDefault();
          if (zoomed) reset(true);
          else if (img) { setZoomed(true, img); zoomAt(img, ZOOM, t.clientX, t.clientY, true); }
        } else {
          lastTap = tm; tapX = t.clientX; tapY = t.clientY;
        }
      } else {
        lastTap = 0;
      }
      if (!e.touches.length) gesture = null;
    }
    track.addEventListener('touchend', endTouch, { passive: false });
    track.addEventListener('touchcancel', endTouch, { passive: false });
    /* Safari iOS : sans cela, le pincement agrandit la page entiere */
    ['gesturestart', 'gesturechange'].forEach(function (n) {
      lb.addEventListener(n, function (e) { e.preventDefault(); });
    });
  }
  /* Galerie repliee : les N premieres images en entier, la rangee suivante en apercu sous un
     degrade, et « View more » qui deplie tout. Ne joue que hors carrousel, et la disposition
     active depend de la largeur (gal-* sur ordinateur, galm-* sur mobile). Les images coupees
     sont `inert` : sinon la tabulation y entrerait et le navigateur ferait defiler la piste
     coupee (overflow: hidden se laisse defiler par programme). */
  function initMore(root) {
    var box = root.querySelector('[data-ss-more]');
    var track = root.querySelector('[data-ss-slides]');
    var btn = box ? box.querySelector('[data-ss-more-btn]') : null;
    if (!box || !track || !btn) return;
    var slides = Array.prototype.slice.call(track.children);
    var count = parseInt(box.getAttribute('data-count'), 10) || 4;
    var peek = (parseInt(box.getAttribute('data-peek'), 10) || 45) / 100;
    var moreLabel = btn.getAttribute('data-more') || btn.textContent.trim() || 'View more';
    var lessLabel = btn.getAttribute('data-less') || '';
    var desk = window.matchMedia('(min-width: 990px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var open = false;
    var frame = 0;
    var timer = 0;
    var cut = -1; /* index de la premiere image coupee, toujours au debut d'une rangee */
    if (slides.length <= count) return;
    if (!btn.textContent.trim()) btn.textContent = moreLabel;

    function mode() {
      var m = root.className.match(desk.matches ? /\bss-pdp--gal-([a-z0-9]+)/ : /\bss-pdp--galm-([a-z0-9]+)/);
      return m ? m[1] : 'carousel';
    }
    function topOf(el) { return el.getBoundingClientRect().top - track.getBoundingClientRect().top; }
    /* En big2, m12 ou m21, slides[count] peut partager la rangee de slides[count - 1] : couper la
       aurait laisse une image a moitie visible ET cliquable. On coupe donc au debut de la rangee
       qui suit celle de la derniere image demandee. Les positions sont celles de la mise en page,
       que max-height et overflow ne deplacent pas. */
    function findCut() {
      var lastTop = topOf(slides[count - 1]);
      for (var i = count; i < slides.length; i++) {
        if (topOf(slides[i]) > lastTop + 1) return i;
      }
      return -1;
    }
    function fullHeight() {
      var last = slides[slides.length - 1];
      return Math.ceil(topOf(last) + last.getBoundingClientRect().height);
    }
    function setInert(from) {
      slides.forEach(function (sl, i) {
        var on = from >= 0 && i >= from;
        sl.inert = on;
        if (on) sl.setAttribute('inert', ''); else sl.removeAttribute('inert');
      });
    }
    function pauseHidden() {
      if (cut < 0) return;
      slides.slice(cut).forEach(function (sl) {
        Array.prototype.forEach.call(sl.querySelectorAll('video'), function (v) { if (!v.paused) v.pause(); });
      });
    }
    /* Les images lazy de la partie coupee ne chargeraient qu'au depliage (cases vides pendant
       l'animation) : on les demande des que la souris ou le clavier approche du bouton. */
    function warm() {
      slides.forEach(function (sl, i) {
        if (i < count) return;
        Array.prototype.forEach.call(sl.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
      });
    }
    function release() {
      track.classList.remove('is-clipped');
      track.style.maxHeight = '';
      setInert(-1);
    }
    function clip() {
      track.scrollTop = 0;
      if (cut < 0) { release(); return; }
      var next = slides[cut];
      var shown = Math.round(next.getBoundingClientRect().height * peek);
      track.style.maxHeight = Math.round(topOf(next) + shown) + 'px';
      box.style.setProperty('--ss-more-fade', shown + 'px');
      track.style.setProperty('--ss-more-fade', shown + 'px');
      track.classList.add('is-clipped');
      setInert(cut);
    }
    function apply() {
      if (!root.isConnected) return;
      var grid = mode() !== 'carousel';
      cut = grid ? findCut() : -1;
      var active = cut >= 0;
      box.hidden = !active || (open && !lessLabel);
      if (!active || open) { release(); return; }
      clip();
    }
    function schedule() {
      if (!root.isConnected) return;
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(apply);
    }

    function expand(instant) {
      if (open) return;
      open = true;
      window.clearTimeout(timer);
      warm();
      setInert(-1);
      box.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      if (instant || reduce.matches || !track.classList.contains('is-clipped')) {
        release();
      } else {
        track.style.maxHeight = Math.max(track.scrollHeight, fullHeight()) + 'px';
        var done = function (e) {
          if (e && e.target !== track) return;
          track.removeEventListener('transitionend', done);
          window.clearTimeout(timer);
          if (open) release();
        };
        track.addEventListener('transitionend', done);
        timer = window.setTimeout(done, 800);
      }
      if (lessLabel) {
        btn.textContent = lessLabel;
      } else {
        box.hidden = true;
        if (!instant) {
          var first = cut >= 0 ? slides[cut].querySelector('button, a, video') : null;
          (first || track).focus({ preventScroll: true });
        }
      }
    }
    function collapse() {
      if (!open) return;
      open = false;
      window.clearTimeout(timer);
      box.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = moreLabel;
      track.style.maxHeight = fullHeight() + 'px';
      void track.offsetHeight; /* on fige la hauteur pleine AVANT de reduire, sinon pas de transition */
      cut = findCut();
      pauseHidden();
      clip();
      /* on garde le bouton sous les yeux. Sa position FINALE = haut de la piste + hauteur coupee :
         la piste est encore en train de se refermer, getBoundingClientRect donnerait l'ancienne. */
      var endTop = track.getBoundingClientRect().top + (parseFloat(track.style.maxHeight) || 0);
      if (endTop < 0) {
        window.scrollBy({ top: endTop - window.innerHeight * 0.6, behavior: reduce.matches ? 'auto' : 'smooth' });
      }
    }

    btn.addEventListener('click', function () { if (open) collapse(); else expand(false); });
    /* le degrade couvre l'apercu : cliquer dessus deplie aussi (le ::before appartient a la boite) */
    box.addEventListener('click', function (e) { if (e.target === box && !open) expand(false); });
    box.addEventListener('pointerenter', warm, { once: true });
    btn.addEventListener('focus', warm, { once: true });

    if (desk.addEventListener) desk.addEventListener('change', schedule);
    else if (desk.addListener) desk.addListener(schedule);
    /* on ne recalcule que si la LARGEUR change : pendant le depliage la hauteur bouge a chaque
       image, et recalculer a ce moment couperait l'animation net */
    if (window.ResizeObserver) {
      var lastW = -1;
      new ResizeObserver(function (entries) {
        var w = Math.round(entries[0].contentRect.width);
        if (w !== lastW) { lastW = w; schedule(); }
      }).observe(track);
    } else {
      window.addEventListener('resize', schedule);
    }

    /* Changement de variante : son image ne doit pas rester sous la coupe. */
    root.__ssMore = {
      reveal: function (index) {
        if (!open && cut >= 0 && index >= cut && !box.hidden) expand(false);
      }
    };
    apply();
    /* Arrivee par ?variant= sur une image de la partie coupee : on ouvre d'emblee, sans animation. */
    var startAt = parseInt(track.getAttribute('data-ss-start'), 10) || 0;
    if (cut >= 0 && startAt >= cut && !box.hidden) expand(true);
  }
  /* Barre d'achat collante. Visible quand le bouton principal est PASSE (son bord bas est au-dessus
     de l'ecran), masquee quand il revient ou que le pied de page entre. Elle n'a pas de logique
     d'achat propre : son bouton clique le vrai bouton du formulaire, et reprend son etat occupe. */
  function initStickyBar(root) {
    var bar = root.querySelector('[data-ss-sbar]');
    var add = root.querySelector('[data-ss-add]');
    var btn = bar ? bar.querySelector('[data-ss-sbar-add]') : null;
    if (!bar || !add || !btn || !('IntersectionObserver' in window)) return;
    var past = false;
    var footIn = false;

    function render() {
      var on = past && !footIn;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) { bar.removeAttribute('inert'); bar.inert = false; } else { bar.setAttribute('inert', ''); bar.inert = true; }
    }
    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      past = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      render();
    }).observe(add);
    var foot = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
    if (foot) {
      new IntersectionObserver(function (entries) {
        footIn = entries[entries.length - 1].isIntersecting;
        render();
      }).observe(foot);
    }

    btn.addEventListener('click', function () {
      if (add.disabled || add.getAttribute('aria-busy') === 'true') return;
      add.click();
    });
    /* le bouton principal passe en « occupe » pendant l'ajout : la barre le montre aussi */
    if (window.MutationObserver) {
      new MutationObserver(function () {
        var busy = add.getAttribute('aria-busy') === 'true';
        if (busy) { btn.setAttribute('aria-busy', 'true'); } else { btn.removeAttribute('aria-busy'); }
      }).observe(add, { attributes: true, attributeFilter: ['aria-busy'] });
    }
  }

  /* Le tiroir du guide des tailles doit vivre HORS de #MainContent : quand un tiroir s'ouvre, le
     shell rend #MainContent inert, et un tiroir reste dedans serait injouable. On le deplace donc
     dans <body> au chargement. Sans JavaScript rien ne bouge, et le repli :target suffit. */
  function moveSizeGuide(root) {
    var sg = root.querySelector('[data-ss-sg]');
    if (!sg || sg.parentNode === document.body) return;
    var twin = document.getElementById(sg.id);
    if (twin && twin !== sg && twin.parentNode === document.body) twin.parentNode.removeChild(twin);
    document.body.appendChild(sg);
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-ss-pdp]'), init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-ss-pdp]'); if (r) init(r); });
})();
